import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LanguajeService } from 'src/app/services/languaje.service';

@Component({
  selector: 'app-tutorial-popover',
  templateUrl: './tutorial-popover.component.html',
  styleUrls: ['./tutorial-popover.component.scss'],
})
export class TutorialPopoverComponent implements OnInit {

  private _unsubscribeAll: Subject<any>;
  @Input() id_tutorial;

  tutorials = {
    1: [
      {
        type: 'title',
        content: {es: '¿Cómo Registrarme?', en: 'How to register?'}
      },
      {
        type: 'text',
        content: {es: null, en: null}
      },
      {
        type: 'img',
        content: {
          es: null,
          en: null}
      },
      {
        type: 'video',
        content: {
          es: 'H1hbg_qI-RA',
          en: 'H1hbg_qI-RA'
        }
      }
    ],
    2: [
      {
        type: 'title',
        content: {es: 'Subir presentación del expositor', en: 'Upload Speaker Presentation'}
      },
      {
        type: 'text',
        content: {es: null, en: null}
      },
      {
        type: 'img',
        content: {
          es: null, 
          en: null
        }
      },
      {
        type: 'video',
        content: {
          es: 'HrEV1ena2e4',
          en: 'HrEV1ena2e4'
        }
      },
      {
        type: 'video',
        content: {
          es: 'B2hxUETv0KA',
          en: 'B2hxUETv0KA'
        }
      }
    ],
  }

  youtubeBaseUrl = "https://www.youtube.com/embed/";

  constructor(
    public popoverController: PopoverController,
    private languajeService:LanguajeService,
  ) {
    this._unsubscribeAll = new Subject();

   }


  tutorial:any;
  typeTitle:any;
  typeText:any;
  typeImg:any;
  typeVideo:any;
  currentLang = "en";

  ngOnInit() {

    this.languajeService.languaje
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe(l =>{
      this.currentLang = l;
    });
    
    this.tutorial = this.tutorials[this.id_tutorial]

    this.typeTitle = this.tutorial?.filter((media) => { return media.type == "title"});
    this.typeText = this.tutorial?.filter((media) => { return media.type == "text" });
    this.typeImg = this.tutorial?.filter((media) => { return media.type == "img" });
    this.typeVideo = this.tutorial?.filter((media) => { return media.type == "video"});

  }

  closePopover(){
    this.popoverController.dismiss();
  }

}
